// components/Header.js
import { useState } from "react";
import {
    AppBar,
    Box,
    Toolbar,
    IconButton,
    Typography,
    Menu,
    Container,
    Button,
    MenuItem,
    Divider,
} from "@mui/material";
// import LanguageIcon from "@mui/icons-material/Language";
import TranslatorWidget from "./TranslatorWidget";
import { useTranslator } from "../context/TranslatorContext";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink, Link} from "react-router-dom";
import { useLocation } from "react-router-dom";
import ldsLogo from "../assets/lds_logo_full_name.svg";
import PersonAddIcon from '@mui/icons-material/PersonAdd';

/* const pages = [
    { label: messages.menu_item_offers_label, path: "/" },
    { label: messages.menu_item_participants_label, path: "/list-of-participants" },
    // { label: "Help", path: "/help" },
]; */

export default function Header() {
    const { language } = useTranslator();
    const {messages} = useTranslator();
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedLang, setSelectedLang] = useState("en"); // or props.lang
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const isParticipantsPage = location.pathname === "/list-of-participants";

    const pages = [
        { label: messages.menu_item_offers_label, language, path: "/" },
        { label: messages.menu_item_participants_label, language, path: "/list-of-participants" },
        // { label: "Help", path: "/help" },
    ];

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <Box component="header" className="header-elc-shadow">
            <Container maxWidth="xl">
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    {/* Top White Logo Bar */}
                    <Box sx={{ backgroundColor: "white", px: 2, py: 1 }}>
                        <Box display="flex" alignItems="center">
                            <Link to="/">
                                <img src={ldsLogo} alt="LDS logo" style={{ width: "18%", paddingTop: "0.5em", paddingBottom: "0.5em" }} />
                            </Link>
                        </Box>
                    </Box>
                    <Box sx={{ ml: 2 }}>
                        <TranslatorWidget />
                    </Box>
                </Box>
            </Container>

            <AppBar position="static" sx={{ backgroundColor: "#00002e" }}>
                <Container maxWidth="lg">
                    <Toolbar disableGutters>

                        {/* Mobile Menu Button */}
                        <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                            <IconButton
                                size="large"
                                aria-label="menu"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>

                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                keepMounted
                                transformOrigin={{ vertical: "top", horizontal: "left" }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{ display: { xs: "block", md: "none" } }}
                            >
                                {pages.map((page, index) => (
                                    <MenuItem
                                        key={index}
                                        onClick={handleCloseNavMenu}
                                        component={RouterLink}
                                        to={page.path}
                                    >
                                        <Typography textAlign="center">{page.label}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        {/* Logo/Title for mobile screens */}
                        <Typography
                            variant="h6"
                            noWrap
                            component={RouterLink}
                            to="/"
                            sx={{
                                flexGrow: 1,
                                display: { xs: "flex", md: "none" },
                                color: "inherit",
                                textDecoration: "none",
                            }}
                        >
                            {messages.main_header_title}
                        </Typography>

                        {/* Desktop Menu Buttons */}
                        <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
                            {pages.map((page, index) => (<>
                                <Button
                                    key={page.label}
                                    component={RouterLink}
                                    to={page.path}
                                    onClick={handleCloseNavMenu}
                                    sx={{ my: 2, color: "white", display: "block" }}
                                >
                                    <Typography variant="h6" sx={{color: "#fff"}}>{page.label}</Typography>
                                </Button>
                                {index < pages.length - 1 && <Divider orientation="vertical" variant="middle" flexItem sx={{ borderColor: "#fff" }} />}
                            </>
                            ))}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            {false && <Box sx={{py: 2 }} className="header-elc-gradient">
                <Container maxWidth="xl">
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                    >
                        <Typography variant="body1" sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
                            {messages.joinText}
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<PersonAddIcon />}
                            color="primary"
                            onClick={() => {
                                // Navigate or trigger modal
                            }}
                        >
                            {messages.joinButton}
                        </Button>
                    </Box>
                </Container>
            </Box>}
        </Box>
    );
}
